import styled from "styled-components";

const DeleteButton = styled.button`
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #dc3545;
  border-radius: 6px;
  color: #dc3545;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #dc3545;
    color: white;
    transform: translateY(-1px);
  }

  &:disabled {
    border-color: #adb5bd;
    color: #adb5bd;
    cursor: not-allowed;
    transform: none;
  }
`;

export default DeleteButton;
